// Registre de géocodage local pour le secteur frontalier (SCBI / Vanessa Tancredi)
export const CITY_COORDINATES = {
    "ottange": [49.4443, 6.0195],
    "dudelange": [49.4800, 6.0833],
    "fontoy": [49.3567, 5.9961],
    "volmerange-les-mines": [49.4422, 6.0803],
    "longwy": [49.5204, 5.7602],
    "mont-saint-martin": [49.5407, 5.7801],
    "herserange": [49.5181, 5.7844],
    "réhon": [49.5019, 5.7550],
    "lexy": [49.5011, 5.7317],
    "villers-la-montagne": [49.4719, 5.7208],
    "saulnes": [49.5317, 5.8239],
    "mercy-le-bas": [49.3811, 5.7603],
    "joppécourt": [49.3828, 5.7903],
    "boismont": [49.4128, 5.7367],
    "bazailles": [49.4008, 5.7725],
    "ville-au-montois": [49.4089, 5.7833],
    "fillières": [49.3697, 5.7303],
    "boudrezy": [49.3881, 5.6792],
    "longuyon": [49.4478, 5.6022],
    "pierrepont": [49.4161, 5.6964],
    "arrancy-sur-crusnes": [49.4128, 5.6567],
    "beuveille": [49.4328, 5.6881],
    "doncourt-lès-longuyon": [49.4386, 5.6372],
    "spincourt": [49.3308, 5.6644],
    "boulange": [49.3828, 6.0022],
    "aumetz": [49.4181, 5.9439],
    "audun-le-roman": [49.3689, 5.9039],
    "trieux": [49.3247, 5.9356],
    "hayange": [49.3297, 6.0622],
    "audun-le-tiche": [49.4725, 5.9572],
    "villerupt": [49.4686, 5.9286],
    "rumelange": [49.4589, 6.0294],
    "esch-sur-alzette": [49.4975, 5.9819],
    "hettange-grande": [49.4061, 6.1558],
    "thionville": [49.3589, 6.1689],
    "yutz": [49.3592, 6.1883],
    "cattenom": [49.4064, 6.2433],
    "roussy-le-village": [49.4561, 6.1739],
    "kanfen": [49.4406, 6.1097],
    "zoufftgen": [49.4631, 6.1347],
    "tressange": [49.4056, 5.9486],
    "havange": [49.3886, 5.9939],
    "russange": [49.4828, 5.9547],
    "rédange": [49.4978, 5.9189],
    "hussigny-godbrange": [49.4936, 5.8731],
    "tiercelet": [49.4628, 5.8825],
    "errouville": [49.4161, 5.9036],
    "crusnes": [49.4350, 5.9281],
    "serrouville": [49.4006, 5.8897],
    "brehain-la-ville": [49.4400, 5.8856],
    "differdange": [49.5219, 5.8886],
    "kayl": [49.4878, 6.0392],
    "schifflange": [49.5086, 6.0125],
    "bettembourg": [49.5186, 6.1017],
    "fentange": [49.5667, 6.1500],
    "piennes": [49.3061, 5.7831],
    "nilvange": [49.3433, 6.0503],
    "algrange": [49.3589, 6.0494],
    "knutange": [49.3378, 6.0397],
    "florange": [49.3225, 6.1189],
    "fameck": [49.3014, 6.1089],
    "uckange": [49.3028, 6.1558],
    "serémange-erzange": [49.3206, 6.0906],
    "neufchef": [49.3175, 6.0247],
    "briey": [49.2486, 5.9381],
    "tucquegnieux": [49.3047, 5.8939],
    "bouligny": [49.2906, 5.7428],
    "joudreville": [49.2969, 5.7725],
    "coin-lès-cuvry": [49.0394, 6.1472],
    "coin-lës-cuvry": [49.0394, 6.1472],
    "coin-les-cuvry": [49.0394, 6.1472],
    "mondelange": [49.2625, 6.1681],
    "thil": [49.4739, 5.9083],
    "xivry-circourt": [49.3481, 5.7533],
    "brouennes": [49.5313, 5.2536],
    "landres": [49.3206, 5.8075],
    "norroy-le-sec": [49.2789, 5.8117],
    "mont-bonvillers": [49.3308, 5.8361],
    "ogy-montoy-flanville": [49.1275, 6.2844],
    "saint-supplet": [49.3817, 5.6103],
    "vilosnes-haraumont": [49.3306, 5.2344],
    "haucourt-moulaine": [49.4906, 5.8058],
    "haucourt moulaine": [49.4906, 5.8058],
    "mancieulles": [49.2828, 5.8925],
    "morfontaine": [49.4444, 5.8117],
    "jarny": [49.1581, 5.8772],
    "cutry": [49.4842, 5.7417],
    "tétange": [49.4744, 6.0417],
    "tetange": [49.4744, 6.0417],
    "montfaucon-d'argonne": [49.2725, 5.1328],
    "escherange": [49.4181, 6.0708],
    "hussigny godbrange": [49.4936, 5.8731]
};

// Siège social d'Ottange par défaut
export const DEFAULT_CENTER = [49.4443, 6.0195];

/**
 * Résout les coordonnées géographiques d'un bien au niveau de sa VILLE uniquement.
 * Pour des raisons de confidentialité et de discrétion, nous n'affichons jamais
 * la localisation exacte (adresse) des biens sur la carte publique.
 */
export function getPropertyCoordinates(property) {
    if (!property) return DEFAULT_CENTER;

    // Utiliser en priorité les coordonnées de la base de données si elles existent et sont valides
    let lat = 0;
    let lng = 0;
    let hasCoords = false;

    if (typeof property.latitude === 'number' && typeof property.longitude === 'number' && property.latitude !== 0 && property.longitude !== 0) {
        lat = property.latitude;
        lng = property.longitude;
        hasCoords = true;
    } else if (property.latitude && property.longitude) {
        const parsedLat = parseFloat(property.latitude);
        const parsedLng = parseFloat(property.longitude);
        if (!isNaN(parsedLat) && !isNaN(parsedLng) && parsedLat !== 0 && parsedLng !== 0) {
            lat = parsedLat;
            lng = parsedLng;
            hasCoords = true;
        }
    }

    if (hasCoords) {
        // Pour garantir la confidentialité et empêcher de retrouver l'adresse exacte du vendeur,
        // nous appliquons un léger décalage déterministe (le marqueur reste stable au même endroit)
        // d'environ 300 à 500 mètres dans une direction aléatoire.
        const idStr = String(property.id || property.netty_ref || "");
        let hash = 0;
        for (let i = 0; i < idStr.length; i++) {
            hash = idStr.charCodeAt(i) + ((hash << 5) - hash);
        }
        // Décalage pseudo-aléatoire entre -0.004 et +0.004 degrés (environ 300 à 450 mètres)
        const latOffset = ((hash % 100) / 100) * 0.008 - 0.004;
        const lngOffset = (((hash >> 8) % 100) / 100) * 0.008 - 0.004;
        return [lat + latOffset, lng + lngOffset];
    }

    const city = (property.city || "").toLowerCase().trim();
    if (!city) return DEFAULT_CENTER;

    // Correspondance exacte
    if (CITY_COORDINATES[city]) {
        return CITY_COORDINATES[city];
    }

    // Correspondance avec tirets à la place d'espaces
    const cityHyphenated = city.replace(/\s+/g, '-');
    if (CITY_COORDINATES[cityHyphenated]) {
        return CITY_COORDINATES[cityHyphenated];
    }

    // Retirer les déterminants comme "les", "sur", etc. pour correspondances floues
    const cleanCity = city.replace(/-(les-mines|sur-crusnes|les|sur|sous)/g, '');
    if (CITY_COORDINATES[cleanCity]) {
        return CITY_COORDINATES[cleanCity];
    }

    // Recherche partielle
    for (const key in CITY_COORDINATES) {
        if (city.includes(key) || key.includes(city)) {
            return CITY_COORDINATES[key];
        }
    }

    return DEFAULT_CENTER;
}
